import { useMemo } from 'react';

import styled from '@emotion/styled';
import { Badge, CheckboxItem, Typography } from '@kc-console/common-ui';

import { MAX_FAVORITE_SERVICE_COUNT } from '../../hooks';

import type { MegaMenuCategory } from '@kc-console/context';

type FavoriteModalBodyProps = {
  allServices: MegaMenuCategory[];
  selected: string[];
  updateServices: (services: string[]) => void;
};

const FavoriteModalBody = ({ allServices, selected, updateServices }: FavoriteModalBodyProps) => {
  /** 즐겨찾기 최대 개수 초과 여부 확인 */
  const isSelectedExceeded = useMemo(() => {
    return selected.length >= MAX_FAVORITE_SERVICE_COUNT;
  }, [selected]);

  const toggleCheckbox = (checked: boolean, name: string) => {
    let refinedSelected = [];

    if (checked)
      // 배열에서 제거
      refinedSelected = selected.filter(serviceName => serviceName !== name);
    else refinedSelected = [...selected, name];

    updateServices(refinedSelected);
  };

  return (
    <FavoriteModalContainer>
      <FavoriteModalLayout>
        {allServices.map(category => {
          return (
            <FavoriteItemsContainer key={category.name}>
              <Typography variant="label/semibold/md">{category.name}</Typography>
              <FavoriteItemContainer>
                {category.services.map(service => {
                  const checked = selected.includes(service.name);
                  /** item 비활성화 조건 : 최대 즐겨찾기 수 초과한 경우 */
                  const isDisabled = !checked && isSelectedExceeded;
                  /** 선택 순서 (1부터 시작), 미선택 시 -1 */
                  const order = selected.indexOf(service.name);

                  return (
                    <CheckboxItem
                      key={service.name}
                      text={
                        checked ? (
                          <FavoriteItemLabel>
                            {service.name}
                            <Badge color="lightGray" variant="filled" label={order + 1} />
                          </FavoriteItemLabel>
                        ) : (
                          service.name
                        )
                      }
                      checked={checked}
                      onChange={() => toggleCheckbox(checked, service.name)}
                      disabled={isDisabled}
                    />
                  );
                })}
              </FavoriteItemContainer>
            </FavoriteItemsContainer>
          );
        })}
      </FavoriteModalLayout>
    </FavoriteModalContainer>
  );
};

export default FavoriteModalBody;

const FavoriteModalContainer = styled.section`
  max-height: 557px;
  overflow-y: auto;
  margin-top: 16px;
`;

const FavoriteModalLayout = styled.ul`
  column-count: 2;
`;

const FavoriteItemsContainer = styled.li`
  break-inside: avoid;

  &:not(last-of-type) {
    margin-bottom: 32px;
  }
`;

const FavoriteItemContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`;

const FavoriteItemLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
